// ##### 25-05-02 Komarov
import React from 'react';
import { useSelector } from 'react-redux';
// ##### 25-05-21 Komarov
import ContentBlock from './ContentBlock/ContentBlock';
import InnerSearchBlock from './InnerSearchBlock/InnerSearchBlock';

// ##### Komarov 2025-07-14
const HotelDetailsContent = props => {
  // ##### Komarov 2025-07-21
  const hotelId = props.searchData?.id;
  // ##### 2025-09-11 Komarov
  const hotelTitle = useSelector(
    state => state.hotelcontent.hotelcontent.data.hotels[hotelId]?.ho_title
  );

  return (
    <>
      <h2>
        {/* ##### 25-02-14 Komarov: если у отеля нет перевода названия (title), то отображаем его системное имя (name) */}
        {hotelTitle || props.hotelName}, {props.cityName}
      </h2>

      <ContentBlock hotel_id={props.searchData?.id} />

      <h3
        style={{
          fontFamily: 'Arial',
          color: '#102D69',
          fontSize: '24px',
          fontWeight: 'bold',
          marginTop: '3vh',
        }}
      >
        {
          // ##### 23-10-04 Komarov
          props.availability
        }
      </h3>

      <InnerSearchBlock
        search_data={props.searchData}
        hotelName={props.hotelName}
      />
    </>
  );
};

export default HotelDetailsContent;
